import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { auditLogApiUrl } from '@/config/audit-log';
import { appendCriteriaEquals, appendCriteriaIn, appendPageable, readPagedRows, } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiUrl = () => auditLogApiUrl('/auditlog/api/v2/audit-logs');
const initialState = {
    loading: false,
    errorMessage: null,
    logs: [],
    totalItems: 0,
};
function appendQueryParam(q, key, value) {
    const trimmed = value?.trim();
    if (trimmed) {
        q.set(key, trimmed);
    }
}
function buildAuditLogParams({ page, size, sort, usernames, activity, startDate, endDate, searchText, }) {
    const q = new URLSearchParams();
    appendPageable(q, page, size, sort);
    appendCriteriaIn(q, 'username', usernames);
    appendQueryParam(q, 'activity', activity);
    appendCriteriaEquals(q, 'startDate', startDate);
    appendCriteriaEquals(q, 'endDate', endDate);
    appendQueryParam(q, 'searchText', searchText);
    return q;
}
export async function fetchAuditLogRows(params) {
    const q = buildAuditLogParams(params);
    const response = await axios.get(`${apiUrl()}?${q.toString()}`);
    return readPagedRows(response.data, response.headers);
}
export const getAuditLogs = createAsyncThunk('auditLog/fetch', async (params) => fetchAuditLogRows(params), { serializeError: serializeAxiosError });
export const AuditLogSlice = createSlice({
    name: 'auditLog',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
        clearErrorMessage(state) {
            state.errorMessage = null;
        },
    },
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getAuditLogs), (state, action) => {
            state.loading = false;
            state.logs = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addMatcher(isPending(getAuditLogs), (state) => {
            state.errorMessage = null;
            state.loading = true;
        })
            .addMatcher(isRejected(getAuditLogs), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset, clearErrorMessage } = AuditLogSlice.actions;
export default AuditLogSlice.reducer;
